import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import { Link, useNavigate } from "react-router-dom";
import { HEADERS_API } from "./NuevaGuia";
import { useState, useEffect, useSyncExternalStore } from "react";
import axios from "axios";
import { mostrarAviso} from "./components/Aviso";
import { NMTipoGuiaRemision} from '../shared/Denominaciones';
import Aviso from "./components/Aviso";
import { ValidarSesion } from "../shared/Validaciones";
import { ValidarNumLtr } from "../shared/Regex";

export default function NuevaSerie(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const[tipoDoc, setTipoDoc] = useState("09");
    const[serie, setSerie] = useState("");
    const[descripcion, setDescripcion] = useState("");
    //ESTADOS DE VALIDACIÓN
    const[datosCompletos, setDatosCompletos] = useState(false);
    // ESTADOS DE SELECT
    const[selectTipoGuia, setSelectTipoGuia] = useState("");
    //#endregion

    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
        ObtenerTiposGuia();
    },[]);

    // VALIDAR QUE LOS DATOS ESTÉN COMPLETOS
    useEffect(()=>{
        try{
            if(tipoDoc == "" || serie == ""){
                throw new Error();
            }

            if(serie.length != 4){
                throw new Error();
            }

            HandlerDatosCompletos(true);
        }catch(error){
            HandlerDatosCompletos(false);
        }
    },[tipoDoc, serie]);

    // ACTUALIZAR PRIMER DÍGITO DE LA SERIE SEGÚN EL TIPO DE GUÍA
    useEffect(()=>{
        switch (tipoDoc) {
            case '09':
                HandlerSerie('T');
                break;
            case '31':
                HandlerSerie('V');
                break;
        }
    },[tipoDoc]);

    //#endregion

    // ======================================================================================================
    //#region  HOOK NAVIGATE
    // ======================================================================================================
    const navigate = useNavigate();
    //#endregion


    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const HandlerTipoDoc = (valor) => setTipoDoc(valor.toString());
    const HandlerSerie = (valor) => {
        let primeraLetra = "";
        switch (tipoDoc) {
            case '09':
                primeraLetra = 'T';
                break;
        
            case '31':
                primeraLetra = 'V';    
                break;
        }

        valor = valor.length <= 1 ? primeraLetra : valor;

        if(ValidarNumLtr(valor)){
            setSerie(valor.toUpperCase());
        }
    } 
    const HandlerDescripcion = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setDescripcion(valor.toUpperCase());
        }
    }
    //ESTADOS DE VALIDACIÓN
    const HandlerDatosCompletos = (valor) => setDatosCompletos(valor);
    //ESTADOS DE SELECT
    const HandlerSelectTipoGuia = (lista) => {
        setSelectTipoGuia(<>{lista.map((item, index)=>(
            <option key={index} value={item.codigo} >{NMTipoGuiaRemision(item.codigo)}</option>
        ))}</>)
    }
    //#endregion

    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    async function ObtenerTiposGuia(){
        try {
            let response = await axios.get(URL_TIPOS_GUIA, {
                headers: HEADERS_API
            }).catch(error => {
                if(error.response){
                    throw new Error(error.response.data.title);
                }else{
                    throw new Error(error.message);
                }
            });

            if(response.mensajeError != null){
                throw new Error(response.mensajeError);
            }

            HandlerSelectTipoGuia(response.data.tipos);
            HandlerTipoDoc(response.data.tipos[0].codigo);
        } catch (error) {
            console.log(error.message);
        }
    }
    const registrarSerie = async () =>{
        try{
            let response = await axios.post(URL_INSERTAR_SERIE,{
                tipoDoc: tipoDoc,
                serie: serie,
                descripcion: descripcion
            },{
                headers:HEADERS_API
            }).catch(error=>{
                throw new Error(error.response.data);
            });
            navigate("/series");
        }catch(error){
            mostrarAviso(error, 2500);
        }
    }
    // FUNCIONES COMPLEMENTARIAS

    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <Aviso/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className='col-12 p-3 text-secondary'>
                <Link className='' to={'/series'}>
                    <button className='btn btn-secondary'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-return-left" 
                        viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"/>
                        </svg>
                        <span className='mx-2'>Regresar</span>
                    </button>
                </Link>
            </div> 
            <div className='col-12 pb-2 fs-3 fw-semibold'>
                NUEVA SERIE
            </div>
            <div className="col-12 col-md-6 p-1">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="filtro-tipo-guia">Tipo GRE</label>
                    <select onChange={(e)=>HandlerTipoDoc(e.target.value)} value={tipoDoc} className="form-select" id="filtro-tipo-guia">
                        {selectTipoGuia}
                    </select>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold">Serie</label>
                    <input onChange={e=>HandlerSerie(e.target.value)} value={serie} maxLength={4} type="text" className="form-control" />
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold">Descripción (Opcional)</label>
                    <input onChange={e=>HandlerDescripcion(e.target.value)} value={descripcion} maxLength={100} type="text" className="form-control" />
                </div>
            </div>
            <div className="col-12 py-3 d-flex justify-content-center align-items-center">
                <button onClick={registrarSerie} disabled={!datosCompletos} className="btn btn-primary">Registrar Serie</button>
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_TIPOS_GUIA = process.env.REACT_APP_URL_TIPOS_GUIA;
const URL_INSERTAR_SERIE = process.env.REACT_APP_URL_INSERTAR_SERIE;
//#endregion